export default __webpack_public_path__ + "static/media/banner.83614ac3.png";